import { Box, Grid, Paper, Typography } from "@mui/material";
import { AppId } from "../../../app/appTypes";
import { StructureTreeView } from "./utils/StructureTreeView";
import { StructureTemplatesView } from "./utils/StructureTemplatesView";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Localized } from "@fluent/react";

export const ClientDocumentTemplatesList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [structureId, setStructureId] = useState<AppId | null>(null);

  const handleStructureSelected = (nodeId: AppId) => {
    setStructureId(nodeId);
    setSearchParams(
      (prev) => {
        const p = new URLSearchParams(prev);
        p.set("structureId", String(nodeId));
        return p;
      },
      { replace: true }
    );
  };

  useEffect(() => {
    const sid = searchParams.get("structureId");
    if (sid) setStructureId(sid as AppId);
  }, [searchParams]);

  return (
    <Box
      sx={{
        height: "calc(100vh - 125px)",
        px: 2,
        py: 2,
      }}
    >
      <Grid container spacing={2} sx={{ height: "100%" }}>
        <Grid item xs={12} md={5} sx={{ height: "100%" }}>
          <Paper
            elevation={3}
            variant="outlined"
            sx={{
              height: "100%",
              p: 2,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }}
          >
            <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
              <StructureTreeView
                editable={false}
                multiselect={false}
                showCounter={true}
                onStructureSelected={handleStructureSelected}
                expandToId={structureId}
              />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={7} sx={{ height: "100%" }}>
          <Paper
            elevation={3}
            variant="outlined"
            sx={{
              height: "100%",
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }}
          >
            <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
              {structureId ? (
                <StructureTemplatesView
                  structureId={structureId}
                />
              ) : (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.secondary",
                  }}
                >
                  <Typography variant="body1">
                    <Localized id={"document-select-structure-to-view-templates"}>
                      <span>_select</span>
                    </Localized>
                  </Typography>
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
